const HIDDEN_CASINO_PROVIDER_CODES = new Set(['011', '015', '017'])

export function isHiddenCasinoProvider (item) {
  return Boolean(item && item.groupCode === 'casino' && HIDDEN_CASINO_PROVIDER_CODES.has(String(item.code)))
}
